import { decomposeColor, rgbToHex } from '@mui/material';
import { lighten } from '@mui/material/styles';

const rgbaToHex = (str: string) => {
  const { values } = decomposeColor(str);
  return rgbToHex(lighten(`rgb(${values.slice(0, 3).join(',')})`, 1 - values[3]!));
};

export default rgbaToHex;
